import React from 'react';
import { DialogTitle, Typography, type SxProps, type Theme } from '@mui/material';

export const flatDialogTitleSx: SxProps<Theme> = {
  px: 2.5,
  py: 2,
  borderBottom: 1,
  borderColor: 'divider',
};

export interface DialogHeaderProps {
  caption?: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  titleNoWrap?: boolean;
  sx?: SxProps<Theme>;
}

/** Flat dialog title — no tinted band or icon badge. */
const DialogHeader: React.FC<DialogHeaderProps> = ({
  caption,
  title,
  subtitle,
  titleNoWrap,
  sx,
}) => (
  <DialogTitle sx={{ ...flatDialogTitleSx, ...sx }}>
    {caption ? (
      <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.25 }}>
        {caption}
      </Typography>
    ) : null}
    <Typography
      variant="h6"
      component="span"
      sx={{ fontWeight: 600, lineHeight: 1.3, display: 'block' }}
      noWrap={titleNoWrap}
      title={titleNoWrap && typeof title === 'string' ? title : undefined}
    >
      {title}
    </Typography>
    {subtitle ? (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }} noWrap>
        {subtitle}
      </Typography>
    ) : null}
  </DialogTitle>
);

export default DialogHeader;
